const initialState = {
  modalDetailPengajuan: true,
  listPengajuan: [],
  listPengajuanSyariah: [],
  listPencairan: [],
  listStatus: [],
  detailPengajuan: [],
  totalPencairan: [],
  valueCol: "12",
  valueColPrev: "0",
  urlPreview: "",
  titlePreview: "",
  getJson: [],
  listScoring: [],
  statusConvert: false,
  closeTabPengajuan: false,
  urlDokumen: "",
  lastTab: "",
  getListKategoriJson: [],
};

const pengajuanReducer = (state = initialState, action) => {
  let { type, data } = action;
  switch (type) {
    case "SET_CLOSE_TAB":
      return {
        ...state,
        closeTabPengajuan: data,
      };
    case "SET_LAST_TAB":
      return {
        ...state,
        lastTab: data,
      };
    case "SET_STEP_PENGAJUAN":
      return {
        ...state,
        modalDetailPengajuan: data,
      };
    case "SET_ALL_STATUS":
      return {
        ...state,
        listStatus: data,
      };
    case "SET_ALL_PENGAJUAN":
      return {
        ...state,
        listPengajuan: data,
      };
    case "SET_ALL_PENGAJUAN_SYARIAH":
      return {
        ...state,
        listPengajuanSyariah: data,
      };
    case "SET_ALL_PENCAIRAN":
      return {
        ...state,
        listPencairan: data,
      };
    case "SET_ALL_SCORING":
      return {
        ...state,
        listScoring: data,
      };
    // case "SET_ALL_JSON":
    // return {
    //   ...state,
    //   listJson: data,
    // };
    case "SET_ALL_TOTAL_PENCAIRAN":
      return {
        ...state,
        totalPencairan: data,
      };
    case "SET_DETAIL_PENGAJUAN":
      return {
        ...state,
        detailPengajuan: data,
      };
    case "PREVIEW_DOKUMEN":
      return {
        ...state,
        valueCol: "6",
        valueColPrev: "6",
        urlPreview: data || "",
        titlePreview: data || "",
      };
    case "HIDE_DOKUMEN":
      return {
        ...state,
        valueCol: "12",
        valueColPrev: "0",
        urlPreview: "",
        titlePreview: "",
      };
    case "SET_ALL_JSON":
      return {
        ...state,
        getJson: data,
      };
    case "SET_ALL_ULANG":
      return {
        ...state,
        statusConvert: data.status,
      };
    case "SHOW_URL_DOKUMEN":
      return {
        ...state,
        urlDokumen: data,
      };
    case "SET_GET_LIST_KATEGORI_JSON":
      return {
        ...state,
        getListKategoriJson: data,
      };
    default:
      return state;
  }
};
export default pengajuanReducer;
